export interface IAdditionalInformation{
  id:number;
  typeId:number;
  effectiveDate:string;
  remarks:string;
  createdAt:string;
  updatedAt:string;
}
